<template>
  <div class="column">
    <div class="container container_com-fundo container_com-margem">
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="visualizar-empreendimento u-margem-superior-pequena">
        <div class="grade__linha grade__linha_alinhar-vertical-centro">
          <span class="grade__coluna">
            <i class="fal fa-chart-network fa-5x"></i>
          </span>
          <div class="grade__coluna grade__coluna_10 informacoes-emprendimento">
            <div class="grade__linha">
              <div class="nome-empreedimento grade__coluna grade__coluna_10">
                <span>{{ cotaDeSubsidio.CidadeNome }}</span>
              </div>
              <button
                v-if="true"
                type="button"
                @click="redirecionarParaEdicao"
                class="no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i>
                Editar
              </button>
            </div>
            <div class="grade__linha">
              <div class="grade__coluna">
                <span class="texto"
                  >Projeto:
                  <span>{{ cotaDeSubsidio.ProjetoNome }}</span>
                </span>
              </div>
              <div class="grade__coluna">
                <span class="texto"
                  >Cotas disponíveis:
                  <span>{{
                    cotaDeSubsidio.Quantidade - cotaDeSubsidio.QuantidadeUsada
                  }}</span>
                </span>
              </div>
              <div class="grade__coluna">
                <span class="texto"
                  >Cotas utilizadas:
                  <span>{{ cotaDeSubsidio.QuantidadeUsada }}</span>
                </span>
              </div>

              <div class="grade__coluna grade__coluna_4">
                <span class="texto"
                  >Total de cotas disponibilizadas:
                  <span>{{ cotaDeSubsidio.Quantidade }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../shared/Loading";
import Alerta from "../shared/Alerta";

export default {
  name: "visualizacao-de-cota",
  components: { Loading, Alerta },
  data() {
    return {
      cotaDeSubsidio: {},
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
    };
  },
  created() {
    const idDaCota = this.$route.query.idDaCota;
    this.exibirCarregamento();
    this.$api
      .get(`/Cotas/${idDaCota}`)
      .then((response) => {
        this.esconderCarregamento();
        this.cotaDeSubsidio = response.data;
        return response;
      })
      .catch((error) => {
        this.tratarErro(error);
      });
  },
  methods: {
    redirecionarParaEdicao() {
      this.$router.push({
        name: "EditarCota",
        query: { idDaCota: this.cotaDeSubsidio.Id },
      });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = "erro";
      const mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta = mensagensDeErro || "Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte";
    },
  },
};
</script>



// WEBPACK FOOTER //
// VisualizarCota.vue?c79f46c0